import React, { useCallback } from "react";
import { styled } from "@mui/material";
import palette from "theme/palette";
import Icon, { AtToggle } from "components/ui/Icon";
import NavIconButton from "./NavIconButton";
import * as O from "fp-ts/lib/Option";
import { pipe } from "fp-ts/function";
import { useController } from "lib/at-react/defineController";
import {
  ToggleMenuController,
  ToggleMenuModalEl,
} from "controllers/AppController/ToggleMenuController";

const NavToggle: React.FC = () => {
  const [toggleMenuModalEl, dispatch] = useController(
    ToggleMenuController,
    ToggleMenuModalEl.get
  );

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      pipe(
        event.currentTarget,
        O.fromNullable,
        ToggleMenuModalEl.set,
        dispatch
      );
    },
    [dispatch]
  );

  return (
    <NavIconButton
      label="Toggle Menu"
      onClick={handleClick}
      sx={{ borderRadius: 50, height: 36, width: 36 }}
    >
      <ToggleIcon icon={AtToggle} size={"24"} />
    </NavIconButton>
  );
};

export default NavToggle;

const ShareIcon = styled(Icon)`
  & *,
  &:hover * {
    transition: fill 0.5s ease;
  }
  & circle {
    fill: ${palette.primary[500]};
  }
  & path {
    fill: ${palette.neutral[100]};
  }
  &:hover circle {
    fill: ${palette.neutral[100]};
  }
  &:hover path {
    fill: ${palette.primary[700]};
  }
`;

const ToggleIcon = styled(Icon)`
  & *,
  &:hover * {
    transition: fill 0.5s ease;
  }
  & circle {
    fill: ${palette.primary[500]};
  }
  & path {
    fill: ${palette.neutral[100]};
  }
  &:hover circle {
    fill: ${palette.neutral[100]};
  }
  &:hover path {
    fill: ${palette.primary[700]};
  }
`;
